"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeechToTextConvertRequestTimestampsGranularity = void 0;
exports.SpeechToTextConvertRequestTimestampsGranularity = {
    None: "none",
    Word: "word",
    Character: "character",
};
